// app/javascript/directives/clicky.js

export default {
  beforeMount(el) {
    el.style.transition = "transform 0.1s ease";
    el.style.cursor = "pointer";
    el.addEventListener("mousedown", () => {
      el.style.transform = "scale(0.98)";
    });
    el.addEventListener("mouseup", () => {
      el.style.transform = "scale(1)";
    });
    el.addEventListener("mouseleave", () => {
      el.style.transform = "scale(1)";
    });
  },
};